import { ApiProperty } from '@nestjs/swagger';
import { UserRegionInterface } from '../interfaces/user-region.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';
import { Expose } from 'class-transformer';
import { UserDto } from '../../user/dto/user.dto';

export class UserRegionDto
  extends CommonEntityDto
  implements UserRegionInterface
{
  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  userId!: string;

  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  regionId!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Manager User ID',
    description:
      'The id of the user that manages this user in this region.' +
      ' Must belong to same region, and have the Regional Manager role',
  })
  @IsUUID()
  @Expose()
  managerUserId!: string;

  @ApiProperty({
    type: () => UserDto,
    title: 'Manager User',
    description:
      'The user that manages this user in this region.' +
      ' Must belong to same region, and have the Regional Manager role',
  })
  @Expose()
  managerUser!: UserDto;
}
